import { isEmpty } from 'lodash';
import { func, object } from 'prop-types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Badge, Card } from 'components';
import { formatDate } from 'helpers';

const TableCard = ({ row, handleRowClick = null }) => {
  const { t } = useTranslation();

  const badgeColor = useMemo(() => {
    switch (row.status) {
      case 'Annulée':
        return 'red';
      default:
        return 'yellow';
    }
  }, [row.status]);

  return (
    <Card className="px-6 py-3">
      <div onClick={() => handleRowClick && handleRowClick(row)}>
        <div className="flex-start-between gap-6 text-gray-600 font-bold text-sm mb-2">
          <span>{row.title}</span>
          <span>{row.amount}€</span>
        </div>

        <div className="flex-center-between mb-4">
          <Badge color={badgeColor} className="text-sm">
            {row.status}
          </Badge>

          {row.balance && (
            <span className="text-gray-500 text-sm">{t('dashboard:balance', { total: row.balance })}</span>
          )}
        </div>

        {row.type === 'Loisir' && !isEmpty(row.delivery) && (
          <div className="flex items-center gap-1 mb-4 text-gray-500">
            <span>{t('dashboard:delivery')}</span>
            <span className="font-bold shrink-0">{row.delivery}</span>
          </div>
        )}

        {row.type === 'Voyage' && !isEmpty(row.docs) && (
          <div className="flex items-center gap-1 mb-4">
            <span className="text-gray-500">{t('dashboard:travelDocuments')}</span>
            <Badge color="green" className="text-sm shrink-0">
              {t('dashboard:available')}
            </Badge>
          </div>
        )}

        <div className="flex-center-between flex-wrap text-gray-500 font-light">
          <span>{row.ref}</span>
          <span>{formatDate(row.date)}</span>
        </div>
      </div>
    </Card>
  );
};

TableCard.propTypes = {
  row: object.isRequired,
  handleRowClick: func
};

export default TableCard;
